<template>
    <div class="col-lg-8">
        <div class="profile-block summary">
            <h3 class="profile-block-heading">
                {{ lang.mainInfo }}
            </h3>
            <div class="profile-box">
                <div class="row">
                    <div class="col-sm-6 col-md-4 mb-5">
                        <div class="profile-box-title mb-1">
                            {{ lang.email }}
                        </div>
                        <div class="profile-box-info">
                            {{ userData.email }}
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-5">
                        <div class="profile-box-title mb-1">
                            {{ lang.firstName }}
                        </div>
                        <div class="profile-box-info">
                            {{ userData.first_name }}
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-5">
                        <div class="profile-box-title mb-1">
                            {{ lang.lastName }}
                        </div>
                        <div class="profile-box-info">
                            {{ userData.last_name }}
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-5">
                        <div class="profile-box-title mb-1">
                            {{ lang.companyName }}
                        </div>
                        <div class="profile-box-info">
                            {{ userData.company_name }}
                        </div>

                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="profile-box-title mb-1">
                            {{ lang.activity }}
                        </div>
                        <div class="profile-box-info">
                            {{ userData.company_activity }}
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="profile-box-slot">
                            <div class="profile-box-title mb-1">
                                {{ lang.phone }}
                            </div>
                            <div class="profile-box-info">
                                {{ userData.phone }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProfileSummary",
        data: function () {
            return {
                lang: jsLangs
            }
        },
        props: {
            userData: ''
        },
    }
</script>
